@if (widgetTreeService.editMode()) {
  <smallstack-markdown-editor
    [translation]="data()"
    (translationChange)="translationChange($event)"
  ></smallstack-markdown-editor>
} @else {
  <smallstack-markdown-viewer [text]="replacedData()"></smallstack-markdown-viewer>
}
